type FitvidsIframeDimensionAttributeValue = string | number | null | undefined;

type FitvidsIframeDimensionAttributes = {
  width?: FitvidsIframeDimensionAttributeValue;
  height?: FitvidsIframeDimensionAttributeValue;
  dataEtOembedWidth?: FitvidsIframeDimensionAttributeValue;
  dataEtOembedHeight?: FitvidsIframeDimensionAttributeValue;
};

/**
 * Parse a positive pixel integer from an iframe dimension attribute value.
 */
const parsePixelAttribute = (value: FitvidsIframeDimensionAttributeValue): number | null => {
  if ('undefined' === typeof value || null === value || '' === value) {
    return null;
  }

  const trimmed = String(value).trim();

  return /^\d+$/.test(trimmed) ? parseInt(trimmed, 10) : null;
};

/**
 * Resolve iframe width/height for FitVids padding-top from markup attributes.
 */
export const resolveFitvidsIframePixelDimensions = (
  attributes: FitvidsIframeDimensionAttributes,
): { width: number; height: number } | null => {
  const attrWidth = parsePixelAttribute(attributes.width);
  const attrHeight = parsePixelAttribute(attributes.height);

  if (null !== attrWidth && null !== attrHeight && 0 < attrWidth && 0 < attrHeight) {
    return {
      width: attrWidth,
      height: attrHeight,
    };
  }

  const dataWidth = parsePixelAttribute(attributes.dataEtOembedWidth);
  const dataHeight = parsePixelAttribute(attributes.dataEtOembedHeight);

  if (null !== dataWidth && null !== dataHeight && 0 < dataWidth && 0 < dataHeight) {
    return {
      width: dataWidth,
      height: dataHeight,
    };
  }

  return null;
};

/**
 * FitVids fluid wrapper padding-top percentage from height/width.
 */
export const getFitvidsPaddingTopPercent = (width: number, height: number): number => (height / width) * 100;
